import React, { useState, useContext, useEffect } from 'react';
import {
	TextField,
	Container,
	Button,
	Paper,
	Typography,
	MenuItem,
	InputLabel,
	Grid,
	FormControl,
	Select,
	InputAdornment,
	IconButton,
	Divider,
	Menu
} from '@mui/material';
import { Stack } from '@mui/system';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
	faSave,
	faPenToSquare,
	faPrint,
	faUserSlash,
	faEllipsisVertical,
	faArrowsRotate,
	faUserTie,
	faFileContract
} from '@fortawesome/free-solid-svg-icons';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import Swal from 'sweetalert2';

import { DataContext } from '../../../../context/DataContext';
import { simpleMessage, validateCedula, isAccess } from '../../../../helpers/Helpers';
import { getToken } from '../../../../api/Account';

import { listarSucursalesAsync } from '../../../../api/Sucursal';
import {
	getEmployeeByIdAsync,
	getPuestosAsync,
	reactivateEmployeeAsync,
	updateEmployeeAsync,
	changeTipoContratoAsync
} from '../../../../api/Employees';
import SmallModal from '../../../../components/modals/SmallModal';
import MediumModal from '../../../../components/modals/MediumModal';
import ChangeSalario from './ChangeSalario';
import ChangeTipoContrato from './ChangeTipoContrato';
import LiquidateEmployee from './LiquidateEmployee';
import PrintLiquidacion from '../liquidacion/PrintLiquidacion';

const EmployeeDetails = ({ id, setEmployeeName, setBasico, isActive, setIsActive }) => {
	const token = getToken();
	const { setIsLoading, setIsUnautorized, access } = useContext(DataContext);

	const [dataEmployee, setDataEmployee] = useState([]);
	const [firstName, setFirstName] = useState('');
	const [secondName, setSecondName] = useState('');
	const [lastName, setLastName] = useState('');
	const [secondLastName, setSecondLastName] = useState('');
	const [identification, setIdentification] = useState('');

	const [puestoList, setPuestoList] = useState([]);
	const [selectedPuesto, setSelectedPuesto] = useState('');

	const [sucursalList, setSucursalList] = useState([]);
	const [selectedSucursal, setSelectedSucursal] = useState('');

	const [inssNumber, setInssNumber] = useState();
	const [salario, setSalario] = useState('');
	const [address, setAddress] = useState('');
	const [fechaInicio, setFechaInicio] = useState(new Date());

	const [tipoContrato, setTipoContrato] = useState(0);
	// const [isActive, setIsActive] = useState(true);

	const [isEdit, setIsEdit] = useState(false);
	const [showEditSalario, setEditSalario] = useState(false);
	const [localReload, setLocalReload] = useState(false);

	const [showModalLiaquidar, setModalLiaquidar] = useState(false);
	const [showModalLiaquidarPrint, setModalLiaquidarPrint] = useState(false);

	const [showChangeTipoContrato, setChangeTipoContrato] = useState(false);

	const [anchorEl, setAnchorEl] = useState(null);
	const handleMenu = (event) => {
		setAnchorEl(event.currentTarget);
	};

	const open = Boolean(anchorEl);

	const handleClose = () => {
		setAnchorEl(null);
	};

	useEffect(() => {
		getSucursals();
		getPuestos();
		getEmployee();
	}, [localReload]);

	const getSucursals = async () => {
		setIsLoading(true);
		const result = await listarSucursalesAsync(token);
		if (!result.statusResponse) {
			setIsLoading(false);
			if (result.error === 'Unauthorized') {
				setIsUnautorized(true);
				return;
			}
			simpleMessage(result.error, 'error');
			return;
		}
		setSucursalList(result.data.result);
		setIsLoading(false);
	};

	const getPuestos = async () => {
		setIsLoading(true);
		const result = await getPuestosAsync(token);
		if (!result.statusResponse) {
			setIsLoading(false);
			if (result.error === 'Unauthorized') {
				setIsUnautorized(true);
				return;
			}
			simpleMessage(result.error, 'error');
			return;
		}
		setPuestoList(result.data.result);
		setIsLoading(false);
	};

	const getEmployee = async () => {
		setIsLoading(true);
		const result = await getEmployeeByIdAsync(token, id);
		if (!result.statusResponse) {
			setIsLoading(false);
			if (result.error === 'Unauthorized') {
				setIsUnautorized(true);
				return;
			}
			simpleMessage(result.error, 'error');
			return;
		}

		setDataEmployee(result.data.result);
		setEmployeeName(result.data.result.fullName);
		setFirstName(result.data.result.firstName);
		setSecondName(result.data.result.secondName);
		setLastName(result.data.result.lastName);
		setSecondLastName(result.data.result.secondLastName);
		setSalario(result.data.result.salario);
		setSelectedPuesto(result.data.result.puesto.id);
		setIdentification(result.data.result.identification);
		setInssNumber(result.data.result.inssNumber);
		setAddress(result.data.result.address);
		setSelectedSucursal(result.data.result.sucursal.id);
		setFechaInicio(new Date(result.data.result.fechaInicioContrato));
		setIsActive(result.data.result.isActive);

		setTipoContrato(result.data.result.tipoContrato);

		setBasico(result.data.result.salario);
		setIsActive(result.data.result.isActive);

		setIsLoading(false);
	};

	//Devuelve un entero positivo
	const funtionSetINSS = (value) => {
		if (/^[0-9]+$/.test(value.toString()) || value === '') {
			setInssNumber(value);
			return;
		}
	};

	const funtionSetSalario = (value) => {
		if (/^\d*\.?\d*$/.test(value.toString()) || value === '') {
			setSalario(value);
			return;
		}
	};

	const saveChanges = async () => {
		if (validate()) {
			const datos = {
				id,
				firstName,
				secondName,
				lastName,
				secondLastName,
				address,
				puestoId: selectedPuesto,
				inss: inssNumber,
				identification,
				salario,
				sucursalId: selectedSucursal,
				fechaInicioContrato: fechaInicio
			};
			setIsLoading(true);

			if (isActive) {
				const result = await updateEmployeeAsync(token, datos);
				if (!result.statusResponse) {
					setIsLoading(false);
					if (result.error === 'Unauthorized') {
						setIsUnautorized(true);
						return;
					}
					simpleMessage(result.error, 'error');
					return;
				}
				setIsLoading(false);
				simpleMessage('Empleado Actualizado...!', 'success');
			} else {
				const result = await reactivateEmployeeAsync(token, datos);
				if (!result.statusResponse) {
					setIsLoading(false);
					if (result.error === 'Unauthorized') {
						setIsUnautorized(true);
						return;
					}
					simpleMessage(result.error, 'error');
					return;
				}
				setIsLoading(false);
				simpleMessage('Empleado Reactivado...!', 'success');
			}
		}
	};

	const validate = () => {
		let isValid = true;
		if (firstName.length === 0) {
			simpleMessage('Debe ingresar un nombre', 'error');
			return (isValid = false);
		}

		if (lastName.length === 0) {
			simpleMessage('Debe ingresar un apellido', 'error');
			return (isValid = false);
		}

		if (identification.length === 0) {
			simpleMessage('Debe ingresar una cédula', 'error');
			return (isValid = false);
		}

		if (!validateCedula(identification)) {
			simpleMessage('Debe ingresar una cédula valida', 'error');
			return (isValid = false);
		}

		if (selectedPuesto.length === 0) {
			simpleMessage('Debe seleccionar un puesto', 'error');
			return (isValid = false);
		}

		if (salario.length === 0) {
			simpleMessage('Debe ingresar un salario', 'error');
			return (isValid = false);
		}

		if (address.length === 0) {
			simpleMessage('Debe ingresar una direccion', 'error');
			return (isValid = false);
		}

		if (selectedSucursal.length === 0) {
			simpleMessage('Debe seleccionar una sucursal', 'error');
			return (isValid = false);
		}

		return isValid;
	};

	const onChangeTipoContrato = () => {
		setChangeTipoContrato(true);
	};

	return (
		<div>
			<Container maxWidth="xl">
				<Paper
					style={{
						padding: 20
					}}
				>
					<Stack
						direction={{ xs: 'column', sm: 'row' }}
						alignItems="center"
						justifyContent={'space-between'}
					>
						<Typography color={'#00a152'} variant="h4" fontWeight={'bold'}>
							Detalle Empleado
						</Typography>

						<Stack direction={'row'} spacing={2} justifyContent="center">
							{isActive ? (
								<Button
									onClick={() => {
										setIsEdit(!isEdit);
									}}
									style={{
										color: '#ffc400',
										borderColor: '#ffc400'
									}}
									variant="outlined"
								>
									<FontAwesomeIcon
										style={{ marginRight: 10, fontSize: 20 }}
										icon={faPenToSquare}
									/>
									Editar
								</Button>
							) : null}

							<IconButton
								style={{
									color: '#ffc400',
									width: 40
								}}
								onClick={handleMenu}
							>
								<FontAwesomeIcon icon={faEllipsisVertical} />
							</IconButton>

							<Menu
								anchorEl={anchorEl}
								anchorOrigin={{
									vertical: 'top',
									horizontal: 'right'
								}}
								keepMounted
								transformOrigin={{
									vertical: 'top',
									horizontal: 'right'
								}}
								open={open}
								onClose={handleClose}
							>
								{isActive ? (
									<>
										<MenuItem onClick={() => setEditSalario(true)}>
											<FontAwesomeIcon
												icon={faArrowsRotate}
												style={{ marginRight: 20 }}
											/>
											Cambiar Salario
										</MenuItem>
										<Divider />

										<MenuItem onClick={() => setModalLiaquidar(true)}>
											<FontAwesomeIcon
												icon={faUserSlash}
												style={{ marginRight: 20 }}
											/>
											Liquidar Empleado
										</MenuItem>

										{isAccess(access, 'CHANGE CONTRACT TYPE') ? (
											<MenuItem onClick={() => onChangeTipoContrato()}>
												<FontAwesomeIcon
													icon={faFileContract}
													style={{ marginRight: 20 }}
												/>
												Cambiar Tipo Contrato
											</MenuItem>
										) : null}
									</>
								) : (
									<>
										<MenuItem onClick={() => setModalLiaquidarPrint(true)}>
											<FontAwesomeIcon
												icon={faPrint}
												style={{ marginRight: 20 }}
											/>
											Imprimir Liquidacion
										</MenuItem>
										<MenuItem
											onClick={() => {
												setIsEdit(true);
												setFechaInicio(new Date());
											}}
										>
											<FontAwesomeIcon
												icon={faUserTie}
												style={{ marginRight: 20 }}
											/>
											Reactivar Empleado
										</MenuItem>
									</>
								)}
							</Menu>
						</Stack>
					</Stack>

					<hr />

					<Grid container spacing={2}>
						<Grid item xs={12} sm={6}>
							<Stack spacing={2}>
								<TextField
									required
									fullWidth
									onChange={(e) => setFirstName(e.target.value.toUpperCase())}
									value={firstName}
									label={'Primer Nombre'}
									disabled={!isEdit}
								/>

								<TextField
									fullWidth
									onChange={(e) => setSecondName(e.target.value.toUpperCase())}
									value={secondName}
									label={'Segundo Nombre'}
									disabled={!isEdit}
								/>
								<TextField
									required
									fullWidth
									onChange={(e) => setLastName(e.target.value.toUpperCase())}
									value={lastName}
									label={'Primer apellido'}
									disabled={!isEdit}
								/>
								<TextField
									fullWidth
									onChange={(e) =>
										setSecondLastName(e.target.value.toUpperCase())
									}
									value={secondLastName}
									label={'Segundo Apellido'}
									disabled={!isEdit}
								/>

								<TextField
									required
									fullWidth
									onChange={(e) =>
										setIdentification(e.target.value.toUpperCase())
									}
									style={{ marginTop: 20 }}
									value={identification}
									label={'Cedula: 000-000000-0000X'}
									disabled={!isEdit}
								/>
								<Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
									<FormControl fullWidth required disabled={!isEdit}>
										<InputLabel id="demo-simple-select-standard-label">
											Seleccione un puesto
										</InputLabel>
										<Select
											labelId="demo-simple-select-standard-label"
											id="demo-simple-select-standard"
											value={selectedPuesto}
											onChange={(e) => setSelectedPuesto(e.target.value)}
											label="Seleccione un puesto"
											style={{ textAlign: 'left' }}
										>
											<MenuItem value="">
												<em>Seleccione un puesto</em>
											</MenuItem>
											{puestoList.map((item) => {
												return (
													<MenuItem key={item.id} value={item.id}>
														{item.description}
													</MenuItem>
												);
											})}
										</Select>
									</FormControl>

									<FormControl fullWidth required disabled>
										<InputLabel id="demo-simple-select-standard-label">
											Tipo de contrato
										</InputLabel>
										<Select
											labelId="demo-simple-select-standard-label"
											id="demo-simple-select-standard"
											value={tipoContrato}
											onChange={(e) => setTipoContrato(e.target.value)}
											label="Tipo de contrato"
											style={{ textAlign: 'left' }}
										>
											<MenuItem key={0} value={0}>
												<em>Seleccione un tipo de contrato</em>
											</MenuItem>

											<MenuItem key={1} value={1}>
												CONTRATO FIJO
											</MenuItem>
											<MenuItem key={2} value={2}>
												SERVICIOS PROFECIONALES
											</MenuItem>
										</Select>
									</FormControl>
								</Stack>
							</Stack>
						</Grid>

						<Grid item xs={12} sm={6}>
							<Stack spacing={2}>
								<TextField
									required
									fullWidth
									onChange={(e) => funtionSetINSS(e.target.value)}
									value={inssNumber}
									label={'Numero INSS'}
									InputLabelProps={{
										shrink: true
									}}
									disabled={!isEdit}
								/>

								<TextField
									fullWidth
									onChange={(e) => funtionSetSalario(e.target.value)}
									value={salario}
									label={'Salario'}
									InputLabelProps={{
										shrink: true
									}}
									InputProps={{
										startAdornment: (
											<InputAdornment position="start">C$</InputAdornment>
										)
									}}
									disabled={!isEdit}
								/>
								<TextField
									required
									fullWidth
									onChange={(e) => setAddress(e.target.value.toLocaleUpperCase())}
									value={address}
									label={'Direccion'}
									disabled={!isEdit}
								/>

								<FormControl
									fullWidth
									style={{ textAlign: 'left', marginTop: 20 }}
									disabled={!isEdit}
								>
									<InputLabel id="demo-simple-select-standard-label">
										Sucursal
									</InputLabel>
									<Select
										labelId="demo-simple-select-standard-label"
										id="demo-simple-select-standard"
										onChange={(e) => setSelectedSucursal(e.target.value)}
										value={selectedSucursal}
										label="Sucursal"
									>
										{sucursalList.map((item) => {
											return (
												<MenuItem key={item.id} value={item.id}>
													{item.description}
												</MenuItem>
											);
										})}
									</Select>
								</FormControl>

								<DesktopDatePicker
									closeOnSelect
									label={isActive ? 'Fecha Ingreso' : 'Fecha Reingreso'}
									inputFormat="DD/MM/YYYY"
									value={fechaInicio}
									onChange={(newValue) => setFechaInicio(newValue)}
									renderInput={(params) => <TextField {...params} />}
									disabled={!isEdit}
								/>

								<Button
									variant="outlined"
									startIcon={
										<FontAwesomeIcon
											icon={faSave}
											style={{ marginRight: 20 }}
										/>
									}
									fullWidth
									onClick={() => saveChanges()}
									style={{
										// marginTop: 30,
										borderRadius: 25,
										color: '#00a152',
										borderColor: '#00a152',
										padding: 13
									}}
									size="large"
									disabled={!isEdit}
								>
									{isActive ? 'Guardar Cambios' : ' Reactivar Empleado'}
								</Button>
							</Stack>
						</Grid>
					</Grid>
				</Paper>
			</Container>

			<SmallModal
				titulo={'Cambiar Tipo de Contrato'}
				isVisible={showChangeTipoContrato}
				setVisible={setChangeTipoContrato}
			>
				<ChangeTipoContrato
					id={id}
					tipoContrato={tipoContrato}
					setShowModal={setChangeTipoContrato}
					reload={localReload}
					setReload={setLocalReload}
				/>
			</SmallModal>

			<SmallModal
				titulo={'Cambiar Salario'}
				isVisible={showEditSalario}
				setVisible={setEditSalario}
			>
				<ChangeSalario
					id={id}
					setShowModal={setEditSalario}
					reload={localReload}
					setReload={setLocalReload}
				/>
			</SmallModal>

			<MediumModal
				titulo={'Liquidar Empleado'}
				isVisible={showModalLiaquidar}
				setVisible={setModalLiaquidar}
			>
				<LiquidateEmployee
					dataEmployee={dataEmployee}
					setShowModal={setModalLiaquidar}
					reload={localReload}
					setReload={setLocalReload}
				/>
			</MediumModal>

			<MediumModal
				titulo={'Liquidacion de Prestaciones Sociales'}
				isVisible={showModalLiaquidarPrint}
				setVisible={setModalLiaquidarPrint}
			>
				<PrintLiquidacion empleadoId={id} />
			</MediumModal>

			{/* <SmallModal
				titulo={'Reactivar Empleado'}
				isVisible={showReactivate}
				setVisible={setReactivate}
			>
				<ReactivateEnployee
					id={id}
					setShowModal={setReactivate}
					reload={localReload}
					setReload={setLocalReload}
				/>
			</SmallModal> */}
		</div>
	);
};

export default EmployeeDetails;
